import React, { Component } from 'react';
import {
	Button,
	Checkbox,
	Col,
	ControlLabel,
	FormControl,
	FormGroup,
	InputGroup,
	Row,
	Table,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';

import { generics } from 'actions';
import { USER_SETUP } from 'actions/const';

import { IS_EMAIL_VALID, IS_VALID } from 'utils';

class Merchant extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			recipient: '',
		};

		this.addRecipient = this.addRecipient.bind(this);
	}

	componentWillMount() {
		let { selectedData } = this.props;

		let { setValue } = this.props.actions;

		this.setState({ isLoading: true });

		if (selectedData.isNew()) {
			this.setState({ isLoading: false });
		} else {
			var merchantQuery = new Parse.Query(Parse.User);
			merchantQuery.include('Merchant');
			merchantQuery.select(['Merchant']);
			merchantQuery
				.get(selectedData.id)
				.then((data) => {
					console.log(data);
					if (data.get('Merchant')) {
						setValue(USER_SETUP, 'merchant', {
							label: data.get('Merchant').get('name'),
							value: data.get('Merchant').id,
						});
					}

					this.setState({ isLoading: false });
				})
				.catch((err) => {
					this.setState({ isLoading: false });
					console.error('Get Merchant error: ', err);
				});
		}

		setValue(
			USER_SETUP,
			'isSendReceiptEmail',
			typeof selectedData.get('isSendReceiptEmail') === 'boolean'
				? selectedData.get('isSendReceiptEmail')
				: false
		);
		setValue(
			USER_SETUP,
			'receiptEmailRecipient',
			Array.isArray(selectedData.get('receiptEmailRecipient'))
				? selectedData.get('receiptEmailRecipient')
				: []
		);
		setValue(
			USER_SETUP,
			'isPrintReceiptEnabled',
			typeof selectedData.get('isPrintReceiptEnabled') === 'boolean'
				? selectedData.get('isPrintReceiptEnabled')
				: false
		);
		setValue(
			USER_SETUP,
			'isReprintReceiptEnabled',
			typeof selectedData.get('isReprintReceiptEnabled') === 'boolean'
				? selectedData.get('isReprintReceiptEnabled')
				: false
		);
		setValue(
			USER_SETUP,
			'reprintLimit',
			IS_VALID(selectedData.get('reprintLimit')) ? selectedData.get('reprintLimit') : ''
		);
	}

	addRecipient() {
		let { recipient } = this.state;

		let { setValue } = this.props.actions;

		let { receiptEmailRecipient } = this.props.usersetup;

		if (!IS_VALID(recipient) || !IS_VALID(recipient.trim())) {
			toast.error('Please enter an email.');
		} else if (!IS_EMAIL_VALID(recipient)) {
			toast.error('Email in not valid.');
		} else {
			let index = receiptEmailRecipient.indexOf(recipient.trim());

			if (index === -1) {
				receiptEmailRecipient.push(recipient.trim());

				setValue(USER_SETUP, 'receiptEmailRecipient', receiptEmailRecipient);
			}

			this.setState({
				recipient: '',
			});
		}
	}

	render() {
		let { isLoading } = this.state;

		let { selectedData, loadOptions } = this.props;

		let {
			merchant,
			isSendReceiptEmail,
			receiptEmailRecipient,
			isPrintReceiptEnabled,
			isReprintReceiptEnabled,
			reprintLimit,
		} = this.props.usersetup;

		let { setValue } = this.props.actions;

		if (isLoading) {
			return (
				<div style={{ textAlign: 'center' }}>
					<i className="fa fa-spinner fa-spin fa-3x fa-lg"></i>
				</div>
			);
		} else {
			return (
				<div>
					<FormGroup>
						<ControlLabel>MERCHANT</ControlLabel>
						<Select.Async
							autoload={false}
							value={merchant}
							loadOptions={(input, cb) => loadOptions(input, cb, 'Merchant', 'name')}
							onChange={(val) => setValue(USER_SETUP, 'merchant', val)}
						/>
					</FormGroup>
					<FormGroup>
						<ControlLabel>
							<Checkbox
								inline
								checked={isSendReceiptEmail}
								onChange={(e) => {
									if (!e.target.checked) {
										this.setState({ recipient: '' });

										setValue(USER_SETUP, 'receiptEmailRecipient', []);
									}

									setValue(USER_SETUP, 'isSendReceiptEmail', e.target.checked);
								}}
							>
								Send Receipt Email
							</Checkbox>
						</ControlLabel>
						<InputGroup>
							<FormControl
								disabled={!isSendReceiptEmail}
								value={this.state.recipient}
								onChange={(e) => {
									this.setState({ recipient: e.target.value.toLowerCase() });
								}}
								onKeyPress={(e) => {
									if (e.key == 'Enter') {
										this.addRecipient();
									}
								}}
							/>
							<InputGroup.Button>
								<Button
									disabled={!isSendReceiptEmail}
									onClick={() => {
										this.addRecipient();
									}}
								>
									ADD
								</Button>
							</InputGroup.Button>
						</InputGroup>
					</FormGroup>
					<Table bordered responsive>
						<tbody>
							<tr>
								<td style={{ textAlign: 'center' }}>RECEIPT EMAIL RECIPIENT</td>
							</tr>
							{receiptEmailRecipient.map((email, index) => {
								return (
									<tr key={index}>
										<td>
											{email}
											<i
												className="fa fa-times-circle fa-lg"
												style={{
													float: 'right',
													marginTop: '2px',
													cursor: 'pointer',
												}}
												onClick={() => {
													let clone = [...receiptEmailRecipient];

													clone.splice(index, 1);

													setValue(
														USER_SETUP,
														'receiptEmailRecipient',
														clone
													);
												}}
											></i>
										</td>
									</tr>
								);
							})}
						</tbody>
					</Table>
					<FormGroup>
						<ControlLabel>
							<Checkbox
								inline
								checked={isPrintReceiptEnabled}
								onChange={(e) => {
									setValue(USER_SETUP, 'isPrintReceiptEnabled', e.target.checked);
								}}
							>
								Print Receipt
							</Checkbox>
							<Checkbox
								inline
								checked={isReprintReceiptEnabled}
								onChange={(e) => {
									setValue(
										USER_SETUP,
										'isReprintReceiptEnabled',
										e.target.checked
									);

									if (!isReprintReceiptEnabled) {
										setValue(USER_SETUP, 'reprintLimit', '');
									}
								}}
							>
								Re-print Receipt
							</Checkbox>
						</ControlLabel>
						<Row>
							<Col md={6}>
								<FormGroup>
									<ControlLabel>Re-print limit</ControlLabel>
									<FormControl
										disabled={!isReprintReceiptEnabled}
										type="number"
										value={reprintLimit}
										onChange={(e) => {
											setValue(USER_SETUP, 'reprintLimit', e.target.value);
										}}
									/>
								</FormGroup>
							</Col>
						</Row>
					</FormGroup>
				</div>
			);
		}
	}

	componentWillUnmount() {
		let { setValue } = this.props.actions;

		setValue(USER_SETUP, 'merchant', null);
		setValue(USER_SETUP, 'isSendReceiptEmail', false);
		setValue(USER_SETUP, 'receiptEmailRecipient', []);
		setValue(USER_SETUP, 'isPrintReceiptEnabled', false);
		setValue(USER_SETUP, 'isReprintReceiptEnabled', false);
		setValue(USER_SETUP, 'reprintLimit', '');
	}
}

function mapStateToProps(state) {
	var { usersetup } = state;
	const props = {
		usersetup,
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue,
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch),
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(Merchant);



// WEBPACK FOOTER //
// ./components/UserSetup/FormContainer/Merchant.js